import React from 'react';
import ReactDOM from 'react-dom';

/**
 * Reusable portal modal wrapper for profile selection modals.
 *
 * Props:
 *   isOpen       - boolean
 *   onClose      - () => void
 *   title        - string
 *   footerLabel  - string (button text, e.g. "Done" or "Cancel")
 *   onFooter     - () => void (optional, defaults to onClose)
 *   contentStyle - object (optional, extra styles for modal-content)
 *   children     - modal body content
 *   selectedSection - ReactNode (optional, rendered between header and body, e.g. selected chips)
 */
const SelectionModal = ({ isOpen, onClose, title, footerLabel, onFooter, contentStyle, children, selectedSection }) => {
    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()} style={contentStyle}>
                <div className="modal-header">
                    <h3>{title}</h3>
                    <button className="close-btn" onClick={onClose}>×</button>
                </div>
                {selectedSection}
                <div className="modal-body" style={contentStyle?.maxHeight ? { overflowY: 'auto', padding: '1rem' } : undefined}>
                    {children}
                </div>
                <div className="modal-footer">
                    <button
                        className="save-btn"
                        onClick={onFooter || onClose}
                        style={{ width: '100%', marginTop: 0 }}
                    >
                        {footerLabel}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default SelectionModal;
